import { render, staticRenderFns } from "./Needcgal.vue?vue&type=template&id=4553d9c2&scoped=true"
import script from "./Needcgal.vue?vue&type=script&lang=js"
export * from "./Needcgal.vue?vue&type=script&lang=js"
import style0 from "./Needcgal.vue?vue&type=style&index=0&id=4553d9c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553d9c2",
  null
  
)

export default component.exports